import sdk from '../services/permissions-sdk';
import { startLoading, endLoading } from './app-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    searchString: '',
    people: [],
    simplePeople: {}
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_PEOPLE   = 'setPeople';
export const SET_SIMPLE_PEOPLE   = 'setSimplePeople';
export const CLEAR_PEOPLE = 'clearPeople';
export const NEW_SET_SIMPLE_PEOPLE = 'newSetSimplePeople';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {

    switch ( action.type ) {
        case SET_PEOPLE: {
            return {
                ...state,
                people: action.people
            };
        }
        case SET_SIMPLE_PEOPLE: {
            return {
                ...state,
                simplePeople: {
                    ...state.simplePeople,
                    [ action.roleId ]: action.people
                }
            };
        }
        case NEW_SET_SIMPLE_PEOPLE: {
            const people = action.people;
            let peopleOptions = [];
            if ( people && people.length > 0 ) {
                peopleOptions = people.map ( person => {
                    return { label: person.givenName + ' ' + person.surname, value: person.id };
                } );
            }
            return {
                ...state,
                simplePeople: action.people,
                peopleOptions
            };
        }
        case CLEAR_PEOPLE: {
            return {
                ...state,
                simplePeople: {}
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function searchPeople( searchString ) {

    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.searchPersons( searchString )
            .then( ( people )=>{

                dispatch( setPeople( people.people ) );
                dispatch( endLoading() );
            }
        ).catch( ( error ) => {
            dispatch( endLoading() );
            console.error( error );
        } );
    };
}
export function searchOnlyPeople( searchString ) {

    return ( dispatch ) => {
        return sdk.searchPersonsSimple( searchString )
            .then( ( people )=>{
                dispatch( setSimplePeople( people.people ) );
            }
        ).catch( ( error ) => {
            console.error( error );
        } );
    };
}
export function clearPeopleSearch() {
    return {
        type: CLEAR_PEOPLE
    };
}

export function oldSearchOnlyPeople( searchString, roleId ) {

    return ( dispatch ) => {
        return sdk.searchPersonsSimple( searchString )
            .then( ( people )=>{
                dispatch( oldSetSimplePeople( people.people, roleId ) );
            }
        ).catch( ( error ) => {
            console.error( error );
        } );
    };
}
export function setSimplePeople( people ) {
    return {
        type: NEW_SET_SIMPLE_PEOPLE,
        people
    };
}
export function oldSetSimplePeople( people, roleId ) {
    return {
        type: SET_SIMPLE_PEOPLE,
        people,
        roleId
    };
}
export function setPeople( people ) {
    return {
        type: SET_PEOPLE,
        people
    };
}
